module.exports = __webpack_public_path__ + "media/images/front/bg-66a957443e8aa89b2f2231f7c33e28a6.jpg";